/**
 * O transcritor da Jev (`tx:`) está na sala agora? É a prova de que algo está sendo transcrito: o ícone de gravação
 * só aparece com ele presente (nunca "no escuro"), e o painel de transcrição usa isto para explicar por que está
 * vazio. Vale para quem usa a sala sem o `TranscriptProvider` (o convidado).
 */
import { useEffect, useState } from 'react';
import { useRoomContext } from '@livekit/components-react';
import { RoomEvent } from 'livekit-client';
import { isTranscriberIdentity } from './transcriptProtocol';

const transcriberIn = (room) => [...(room?.remoteParticipants?.values?.() ?? [])].some((p) => isTranscriberIdentity(p.identity));

/** @returns {boolean} */
export function useTranscriberPresent() {
    const room = useRoomContext();
    const [present, setPresent] = useState(() => transcriberIn(room));

    useEffect(() => {
        if (!room) return undefined;
        setPresent(transcriberIn(room));
        const onConnected = (participant) => { if (isTranscriberIdentity(participant?.identity)) setPresent(true); };
        const onDisconnected = (participant) => { if (isTranscriberIdentity(participant?.identity)) setPresent(false); };
        const resync = () => setPresent(transcriberIn(room));
        room.on(RoomEvent.ParticipantConnected, onConnected);
        room.on(RoomEvent.ParticipantDisconnected, onDisconnected);
        room.on(RoomEvent.Reconnected, resync);
        return () => {
            room.off(RoomEvent.ParticipantConnected, onConnected);
            room.off(RoomEvent.ParticipantDisconnected, onDisconnected);
            room.off(RoomEvent.Reconnected, resync);
        };
    }, [room]);

    return present;
}
